import script from "./AppEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppEditor.vue?vue&type=script&lang=ts&setup=true"

import "./AppEditor.vue?vue&type=style&index=0&id=32052e70&lang=css"

const __exports__ = script;

export default __exports__